import { FileUploadService, FileType } from '@bold/file-upload-service';
import { WorkItemTypes } from '../../../common/workitems/constants/workitem-types';

export class BoldUploadService extends FileUploadService {
  _getTokenRequestParams(chatId, fileName, fileSize, fileType: FileType) {
    let params: any = super._getTokenRequestParams(chatId, fileName, fileSize, fileType);
    params.workItemType = this.config.workItemType === WorkItemTypes.ASYNC_MESSAGE ? 'ASYNC_CHAT' : this.config.workItemType || WorkItemTypes.CHAT;

    return params;
  }

  _getTokenRegisterUrl(token) {
    let url = super._getTokenRegisterUrl(token);
    let wt = this.config.workItemType === WorkItemTypes.ASYNC_MESSAGE ? 'ASYNC_CHAT' : this.config.workItemType || WorkItemTypes.CHAT;

    return `${url}?workItemType=${wt}`;
  }
}
